import { render } from "./LottieTabs.vue?vue&type=template&id=1f151436"
import script from "./LottieTabs.vue?vue&type=script&lang=js"
export * from "./LottieTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/net-price/LottieTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f151436"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f151436', __exports__)) {
    api.reload('1f151436', __exports__)
  }
  
  module.hot.accept("./LottieTabs.vue?vue&type=template&id=1f151436", () => {
    api.rerender('1f151436', render)
  })

}


export default __exports__